export default "__VITE_ASSET__746dbfc1__"